import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=a2c760e0&scoped=true"
import script from "./activityDetails.vue?vue&type=script&lang=js"
export * from "./activityDetails.vue?vue&type=script&lang=js"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=a2c760e0&prod&lang=scss&scoped=true"
import style1 from "./activityDetails.vue?vue&type=style&index=1&id=a2c760e0&prod&lang=css"
import style2 from "./activityDetails.vue?vue&type=style&index=2&id=a2c760e0&prod&lang=scss&scoped=true"
import style3 from "./activityDetails.vue?vue&type=style&index=3&id=a2c760e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c760e0",
  null
  
)

export default component.exports